// extracted by mini-css-extract-plugin
module.exports = {"menuListContainer":"az_jeb","link":"az_keb"};